import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/security/twoFactorDisable';
import { clear as clearEnable } from '../../actions/security/twoFactorEnable';
import { clear as clearRecoveryCodes } from '../../actions/security/twoFactorRecoveryCodes';
import { fetchRequest as fetchStatus } from '../../actions/security/twoFactorStatus';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error as ErrorAction } from '../../actions/error/error';

function* operation(action) {
  try {
    yield call(
      axios.post,
      `${config.API_URL}/user/2fa/disable`,
      { code: action.payload.code },
      { headers: getLocalUser() },
    );
    // Disabling wipes any recovery codes still on screen.
    yield put(clearEnable());
    yield put(clearRecoveryCodes());
    yield put({ type: 'SHOW_SUCCESS_SNACKBAR', message: 'Two-factor authentication disabled' });
    yield put(fetchStatus());
    yield put(fetchSuccess({ disabled: true }));
  } catch (err) {
    yield put(ErrorAction(err));
    const message = err?.response?.data?.data?.message
      || err?.response?.data?.message
      || 'That code didn\'t work';
    yield put({ type: 'SHOW_ERROR_SNACKBAR', message });
    yield put(fetchFailure(message));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, operation);
}
